<template>
  <section class="section">
    <LazyBg :src="bgSrc" />
    <div class="container">
      <h2 class="section-title">算力服务优势</h2>
      <p class="section-lead">灵活的资源配置、稳定的服务保障、透明的计费体系</p>
      <div class="features-grid">
        <div v-for="f in features" :key="f.title" class="feature-card">
          <div class="feature-icon" v-html="f.icon" />
          <h3>{{ f.title }}</h3>
          <p>{{ f.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import bgSrc from '@/assets/AIservices_bg2.jpg';
import LazyBg from '@/components/LazyBg.vue';
const features = [
  {
    title: '秒级弹性扩缩',
    desc: '资源池化调度，支持秒级自动扩缩容，轻松应对业务高峰，无需提前采购硬件。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>'
  },
  {
    title: '按需付费',
    desc: '按实际使用时长计费，精确到秒，无预付费用，显著降低算力使用成本。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></svg>'
  },
  {
    title: '多粒度资源',
    desc: '从单卡到千卡级别，支持 GPU 切片、多卡互联等多种资源配置方案。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5M2 12l10 5 10-5"/></svg>'
  },
  {
    title: '高速互联',
    desc: '节点间采用 100Gbps+ RDMA 高速互联，满足分布式训练和大规模并行计算需求。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="5" cy="12" r="2"/><circle cx="19" cy="5" r="2"/><circle cx="19" cy="19" r="2"/><path d="M7 12h4l3-5 3 10"/></svg>'
  },
  {
    title: '稳定可靠',
    desc: '99.95% SLA 保障，多副本冗余存储，7×24 小时监控与故障自动迁移。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>'
  },
  {
    title: '安全合规',
    desc: '物理隔离、网络加密、权限管控，满足金融、医疗等行业的安全合规要求。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>'
  }
];
</script>
<style scoped lang="scss">
.container {
  position: relative;
  z-index: 1;
}

 .section {
  /* bg via LazyBg */
}
</style>